import { render, staticRenderFns } from "./arrivalDetailsModal.vue?vue&type=template&id=5128b2ce&scoped=true"
import script from "./arrivalDetailsModal.vue?vue&type=script&lang=js"
export * from "./arrivalDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128b2ce",
  null
  
)

export default component.exports